<template>
  <div
      v-if="showComponent"
      :title="qaAble ? showIfHasPermission?.toString() : null"
      style="padding-right: 5px;padding-left: 5px; padding-bottom: 5px; position: relative;"
      :key="componentRefresh"
  >
    <input
        :id="'ks-input-search-'+_uid"
        type="text"
        :placeholder="placeholder"
        class="form-control"
        :disabled="!enableComponent || disabled"
        :class="[inputclasses]"
        @focus="showOptions"
        @blur="hideOptions"
        v-model="searchTerm"
        @input="inputSearchEvent($event.target.value)"
        @keypress.enter.prevent=""
        autocomplete="new-password"
    >
    <span
        class="icon-inside-sm"
        v-if="classIcon && !searchTerm"
    >
      <i :class="classIcon"/>
    </span>
    <span
        v-if="searchTerm"
        class="icon-inside-sm-clear"
    >
<!--        style="position: absolute; top: 0; right: 0;"-->
        <i
            class="far fa-times-circle mb-0 text-danger pointer"
            style="color: darkred; cursor: pointer; font-size: 1.125rem;"
            @click.prevent="clearSearch()"
        />
      </span>
    <div
        v-show="enableOptions && isValidTerm"
        class="main-search-content"
        :style="contentStyle"
        :id="`ks-input-search-infinite-list-${_uid}`"
    >
      <div style="position:fixed;float:right;margin-left:16vh">
        <!--        <small
                    v-if="!isEmpty && totalPages > 0"
                    class="text-muted"
                >
                  Page {{ page + 1 }} of {{ totalPages }} | {{ totalRecords }} Records
                </small>-->
        <span
            v-show="loadingList"
            style="float:right"
        >
          <i class="fas fa-spinner fa-pulse"></i>
        </span>
      </div>
      <div
          class="d-flex flex-row justify-content-between"
          :class="!isEmpty && totalPages > 0 ? 'pt-4' : ''"
      >
        <router-link to="/new-lead">New Lead</router-link>
        <router-link to="/new-customer">New Customer</router-link>
        <router-link to="/new-vendor">New Vendor</router-link>
        <ks-button classIcon="fas fa-trash-alt" classes="p-0 m-0" color="link" @onClick="setSolicitor"/>
      </div>
      <template v-if="isEmpty">
        <strong>No match</strong>
      </template>
      <template
          v-for="(listDef, listIdx) in listResultSet"
          v-else
      >
        <template v-if="lists[listDef.dataSource]&&lists[listDef.dataSource].length > 0">
          <span
              v-if="listDef.title"
              class="main-search-title"
              :key="'title_'+listIdx"
          >
              <strong>{{ listDef.title }}</strong> <br>
          </span>
          <template
              v-for="(option, optionsIdx) in lists[listDef.dataSource]"
          >
            <span
                class="main-search-item"
                :key="`options_${listDef.dataSource}_${optionsIdx}`"
            >
              <template v-if="listDef.linkTemplate">
                <a
                    href=""
                    @click.prevent="changeOption(option, listDef)"
                >
                  {{ getStrTemplateWithValues(listDef.linkTemplate, option) }}
                </a>
              </template>
              <template v-else-if="listDef.HTMLTemplate">
                <div
                    @click.prevent="changeOption(option, listDef)"
                    v-html="getStrTemplateWithValues(listDef.HTMLTemplate, option)">
                </div>
              </template>
              <br>
            </span>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex';
import checkPermissions from '../../mixins/checkPermissions';

var timeout = null;
export default {
  name: "ks-input-search",
  mixins: [checkPermissions],
  props: {
    id: {
      type: String,
      default: ""
    },
    useFacility: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contactSearchIdCSV: {
      type: String,
      default: '1,2,3,4,5', //(1=Lead, 2=contact, 3=customer, 4=employee, 5=vendor.)
    },
    campaignId: {
      default: null
    },
    classIcon: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    inputclasses: {
      type: String,
    },
    filters: {
      type: Object,
      default: function () {
        return {}
      }
    },
    listResultSet: {
      type: Array,
      required: true
    },
    width: {
      type: String,
      default: '250px'
    },
    height: {
      type: String,
      default: 'calc(100vh - 600px)'
    },
    limitRecords: {
      type: Number,
      default: 30
    }
  },
  mounted() {
    app[`mainInputSearch${this.id}`] = this;
    this.infiniteList = document.querySelector(`#ks-input-search-infinite-list-${this._uid}`);
    this.infiniteList.addEventListener('scroll', e => {
      if (this.infiniteList.scrollTop + this.infiniteList.clientHeight >= this.infiniteList.scrollHeight) {
        let aux = this.page + 1;
        if ((aux * this.limitRecords) <= this.totalRecords) {
          this.page++;
          if (this.consoleLogs) console.log("input search loadList");
          this.loadList(true);
        }
      }
    });
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    ...Vuex.mapGetters({selected_campaigns: 'rms_ui/auth/selected_campaigns'}),
    /*selectedFacility: {
      get() {
        return global.app.store.state.rms_ui.auth.selected_facility;
      },
      set(val) {
        if (val) {
          app.store.commit('rms_ui/auth/setSelectedFacility', val);
        }
      }
    },*/
    selected_campaign() {
      return app.store.state.rms_ui.auth.single_campaign;
    },
    contentStyle() {
      return {'width': this.width, 'height': this.height, 'overflow-y': 'auto'}
    },
    isValidTerm() {
      return this.searchTermLength >= 2 ? true : false;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  methods: {
    setSolicitor() {
      if (app['mainInputSearch']) {
        app['mainInputSearch'].setSearchTerm('solicit');
        setTimeout(() => {
          app['mainInputSearch'].focus();
          this.showOptions();
        }, 500);
        if (app.menuComponent && this.screenSizeId < 3) {
          app.menuComponent.enableInputSearch();
        }
      }
    },
    clearSearch() {
      this.searchTerm = null;
      this.inputSearchEvent(this.searchTerm);
      setTimeout(() => this.focus(), 300);
      this.$emit("onClear", {'object_id': null}, null);
    },
    inputSearchEvent(value) {
      this.searchTermLength = value ? value.length : 0;
      if (this.selectedOption == null || value !== this.selectedOption['__strValue']) {
        if (timeout || value.length < 2) {
          clearTimeout(timeout);
        }
        if (value?.length >= 2) {
          timeout = setTimeout(() => {
            this.clearLists();
            if (this.consoleLogs) console.log("inputSearchEvent loadList");
            this.loadList();
          }, 1000);
        }
      }
    },
    focus() {
      document.getElementById(`ks-input-search-${this._uid}`).focus();
      this.showOptions();
    },
    setSearchTerm(str, search = true) {
      this.searchTerm = str;
      if (search) this.inputSearchEvent(str);
    },
    clearLists() {
      this.lists.leads = [];
      this.lists.customers = [];
      this.lists.employees = [];
      this.lists.vendors = [];
      this.lists.contacts = [];
      this.page = 0;
      this.totalRecords = 0;
      this.totalPages = 0;
      this.isEmpty = true;
      this.infiniteList.scrollTop = 0;
    },
    async loadList(push = false) {
      try {
        this.loadingList = true;
        this.isEmpty = false;
        let campaignId = this.campaignId !== null && `${this.campaignId}`.length > 0 ? `${this.campaignId}` : this.selected_campaigns.map(cp => cp.id).join();
        let single_campaign_id = null;
        /*if (this.useFacility) {
          let campaignIds = campaignId.split(",");
          single_campaign_id = campaignIds.find(campaign_id => campaign_id === this.selectedFacility ? this.selectedFacility.campaign_id : null);
        }*/
        let send_data = {
          'campaign_id': campaignId,
          'search_string': this.searchTerm,
          'object_type_id_csv': this.contactSearchIdCSV,
          'row_count_skip': this.page * this.limitRecords,
          'row_count_take': this.limitRecords,
          ...this.filters
        };
        let res = await app.sdk['market']['market_search_list'](this.auth.token, send_data);
        if (res.list && res.list.length > 0) {
          this.totalRecords = res.result_set[0].total_row_count;
          this.totalPages = Math.ceil(this.totalRecords / this.limitRecords);
          this.lists.leads = push ? [...this.lists.leads, ...res.list.filter(item => item.object_type_id === 1)] : res.list.filter(item => item.object_type_id === 1);
          this.lists.contacts = push ? [...this.lists.contacts, ...res.list.filter(item => item.object_type_id === 2)] : res.list.filter(item => item.object_type_id === 2);
          this.lists.customers = push ? [...this.lists.customers, ...res.list.filter(item => item.object_type_id === 3)] : res.list.filter(item => item.object_type_id === 3);
          this.lists.employees = push ? [...this.lists.employees, ...res.list.filter(item => item.object_type_id === 4)] : res.list.filter(item => item.object_type_id === 4);
          this.lists.vendors = push ? [...this.lists.vendors, ...res.list.filter(item => item.object_type_id === 5)] : res.list.filter(item => item.object_type_id === 5);
        } else {
          this.clearLists();
        }
        this.loadingList = false;
      } catch (err) {
        console.log('KS-APP: ', err);
        this.loadingList = false;
        this.clearLists();
        throw err;
      }
    },
    showOptions() {
      this.enableOptions = true;
    },
    hideOptions() {
      setTimeout(() => {
        this.$emit('blur', this);
        this.enableOptions = false;
      }, 200);
    },
    changeOption(option, def) {
      this.selectedOption = JSON.parse(JSON.stringify(option));
      this.selectedOption['__strValue'] = def.value ? option[def.value] : (def.valueTemplate ? this.getStrTemplateWithValues(def.valueTemplate, option) : null);
      this.searchTerm = this.selectedOption['__strValue'];
      this.$emit('change', option, def.dataSource);
    },
    getStrTemplateWithValues(str, data) {
      let template = str;
      str.replace(/\${(.*?)}/g, (a, b) => {
        if (data[b] !== undefined) {
          template = template.replace(a, data[b]);
        }
      });
      return template;
    }
  },
  data() {
    return {
      infiniteList: null,
      page: 0,
      totalRecords: 0,
      totalPages: 0,
      searchTermLength: 0,
      searchTerm: null,
      enableOptions: false,
      selectedOption: null,
      lists: {
        leads: [],
        customers: [],
        vendors: [],
        employees: [],
        contacts: []
      },
      isEmpty: false,
      loadingList: false
    }
  }
}
</script>

<style>
.main-search-content {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10000;
  background: white;
  border: 1px solid black;
  border-radius: 4px;
  padding: 10px;
  box-shadow: rgb(136, 136, 136) 5px 8px 7px;
  margin-top: 45px;
  overflow: hidden auto;
  font-size: 16px;
}

.main-search-title {
  border-bottom: 1px solid lightgrey;
}

.main-search-item {
  padding: 5px 10px;
}

</style>
